import { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';
import { setCookieConsent, hasGivenConsent } from '../utils/cookieConsent';
import { useLanguage } from '../contexts/LanguageContext';

export default function CookieConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    if (!hasGivenConsent()) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }

    const handleOpenSettings = () => {
      setIsVisible(true);
    };

    window.addEventListener('openCookieSettings', handleOpenSettings);
    return () => window.removeEventListener('openCookieSettings', handleOpenSettings);
  }, []);

  const handleAccept = () => {
    setCookieConsent({ necessary: true });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 w-full max-w-xl px-4 animate-fade-in">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div className="h-1 bg-gradient-to-r from-blue-600 to-cyan-500" />

        <div className="p-5">
          <div className="flex items-start gap-3 mb-4">
            <div className="w-9 h-9 bg-blue-50 dark:bg-blue-900/30 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5">
              <Cookie className="w-4 h-4 text-blue-600 dark:text-blue-400" />
            </div>
            <div className="flex-1 min-w-0">
              <h2 className="text-sm font-bold text-gray-900 dark:text-white mb-1">
                {t('cookie.title')}
              </h2>
              <p className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed">
                {t('cookie.desc1')}{' '}
                <a href="/datenschutz" className="text-blue-600 dark:text-blue-400 hover:underline">
                  {t('cookie.privacy')}
                </a>{' '}
                {t('cookie.and')}{' '}
                <a href="/cookie-richtlinie" className="text-blue-600 dark:text-blue-400 hover:underline">
                  {t('cookie.policy')}
                </a>.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-2">
            <button
              onClick={handleAccept}
              className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-xl text-sm font-bold hover:bg-blue-700 transition-all shadow-md"
            >
              {t('cookie.accept')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
